import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStepBack = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.68565 4.70837L6.93565 6.45837H13.875C17.1657 6.45837 19.8333 9.126 19.8333 12.4167C19.8333 15.7074 17.1657 18.375 13.875 18.375H6.04166V16.875H13.875C16.3373 16.875 18.3333 14.879 18.3333 12.4167C18.3333 9.95443 16.3373 7.95837 13.875 7.95837H6.93565L8.68565 9.70837L7.62499 10.769L4.06433 7.20837L7.62499 3.64771L8.68565 4.70837Z",
		fill: "currentColor"
	})]
});
export default SvgStepBack;
